import { render, staticRenderFns } from "./Summary.html?vue&type=template&id=f929dbb0&scoped=true&"
import script from "./Summary.js?vue&type=script&lang=js&"
export * from "./Summary.js?vue&type=script&lang=js&"
import style0 from "./Summary.scss?vue&type=style&index=0&id=f929dbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f929dbb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTabItem})
